import { IPromoInfo } from '../../types/redux/promoInfo';

export const promoInfoDefaultState: IPromoInfo = {
  additionalServices: [],
  pricing: { methods: [] },
};

export function promoInfoReducer(state: IPromoInfo = promoInfoDefaultState) {
  return state;
}
